<template>
    <div class="my-purchase-review">
        <v-toolbar app dark dense color="primary" flat>
            <v-btn icon flat small @click="$router.push({path: '/my-purchase?status=3'})">
                <v-icon>arrow_back</v-icon>
            </v-btn>
            <v-toolbar-title class="white--text subheading">Review Product</v-toolbar-title>
        </v-toolbar>

        <div class="rate-head-container">
            <v-container>
                <div class="rate-head">
                    <div class="rate-head__label">
                        <v-icon>store</v-icon>
                        <div class="title ml-2">{{shopData.name}}</div>
                    </div>
                    <div class="rate-head__review">
                        <div class="rate-head__text caption font-weight-medium">Rate This Seller</div>
                        <div class="rate-head__icons">
                            <img width="40" src="../../assets/svgs/ratings/face-sad.svg" alt="">
                            <img width="40" src="../../assets/svgs/ratings/face-neutral.svg" alt="">
                            <img width="40" src="../../assets/svgs/ratings/face-happy.svg" alt="">
                        </div>
                    </div>
                </div>
            </v-container>
        </div>

        <input
                type="file"
                @change="handleFileChange"
                style="display:none;"
                ref="fileInput"
                accept="image/*,video/*"
                name="video"
                capture="capture"
        />

        <div v-for="(data, index) in formData" class="rate-card-container my-2">
            <div class="rate-card">
                <div class="rate-card__head">
                    <div class="rate-card__image-holder">
                        <div class="rate-card__image" :style="{'background-image': `url('${data.product_image}')`}"></div>
                    </div>
                    <div class="rate-card__title body-1 font-weight-medium ml-2">
                        {{data.product_name}}
                    </div>
                </div>
                <div class="rate-card__actions">
                    <div class="rate-card__actions-text caption font-weight-medium">
                        Rate This Product
                    </div>
                    <div class="rate-card__actions-button">
                        <v-rating v-model="formData[index].rating" color="#fe6347" medium dense></v-rating>
                    </div>
                </div>
                <div class="rate-card__textbox">
                    <v-textarea v-model="formData[index].comment" outline name="input-7-4" placeholder="Item review..." hide-details></v-textarea>
                </div>
                <div class="rate-card__video">
                    <a v-if="formData[index].media_type == 'image'" data-fancybox="gallery" :href="formData[index].src">
                        <v-img  :src="formData[index].src" aspect-ratio="1.7" contain></v-img>
                    </a>
                    <video v-if="formData[index].media_type == 'video'" height="200" controls :src="formData[index].src" type="video/mp4">
                        Your browser does not support HTML5 video.
                    </video>
                    <div class="rate-card__add-video">
                        <v-btn color="info" class="text-capitalize" outline depressed @click.native="triggerUpload(index)">
                            <v-icon small>add</v-icon>
                            Add Media
                        </v-btn>
                        <v-btn color="info" class="text-capitalize" depressed @click="submitReview(index)">Submit</v-btn>
                    </div>
                </div>
            </div>
        </div>
        <loader v-show="loading"></loader>
    </div>
</template>
<script>
    import Loader from "../../components/Loader";
    export default {
        name: 'MyPurchase',
        components: {Loader},
        data() {
            return {
                formData    : [],
                rating      : 5,
                loading : false,
                shopData : {},
                selectedUploadIndex : '',
            }
        },
        methods: {
            getData(){
                this.loading = true;
                axios.get(`/api/order/${this.$route.params.order_id}?showAll=1`)
                    .then(res => {
                        this.formatData(res.data.data);
                        this.loading = false;
                    })
                    .catch(err => {
                        // this.toaster('something went wrong.', 201);
                    });
            },
            formatData(data){
                this.loading = false;
                this.shopData = data.shop;
                this.formData = [];
                data.order_items.map((value,index)=>{
                    let variation = value.branch_variation.variation;
                    let product = variation.product.name + (typeof variation.variation_options[0] !== "undefined" ? `(${variation.variation_options[0].name}) ` : '') + (typeof variation.variation_options[1] !== "undefined" ? `(${variation.variation_options[1].name})` : '');
                   if (value.review){

                   }
                   else{
                       this.formData.push({
                           user_id                 : data.user_id,
                           order_item_id           : value.id,
                           product_id              : value.product_id,
                           branch_variation_id     : value.branch_variation_id,
                           file                    : null,
                           src                     : '',
                           comment                 : '',
                           rating                  : 3,
                           media_type              : '',
                           product_name            : product,
                           product_image           : variation.product.galleries[0].url_optimized,
                       });
                   }

                });
            },
            submitReview(index){

                let formData = new FormData();
                if (this.formData[index].file){
                    formData.append('file', this.formData[index].file, this.formData[index].file.name);
                }
                formData.append('user_id', this.formData[index].user_id);
                formData.append('order_item_id', this.formData[index].order_item_id);
                formData.append('product_id', this.formData[index].product_id);
                formData.append('branch_variation_id', this.formData[index].branch_variation_id);
                formData.append('comment', this.formData[index].comment);
                formData.append('rating', this.formData[index].rating);
                formData.append('media_type', this.formData[index].media_type);
                formData.append('product_name', this.formData[index].product_name);
                formData.append('product_image', this.formData[index].product_image);
                this.loading = true;
                axios.post('/api/review', formData)
                    .then(res =>{
                        this.formData.splice(index,1);
                        if (this.formData.length == 0 ){
                            this.$router.push({path : '/my-purchase?status=3'});
                            this.toaster('Successfully reviewed and rated product ', 200);
                        }
                        this.loading = false;
                    })
                    .catch(err => {
                        this.toaster('something went wrong', 201);
                    });
            },
            triggerUpload (index) {
                this.$refs.fileInput.click();
                this.selectedUploadIndex = index;
            },
            handleFileChange(e){
                    let file = e.target.files[0];

                    if (file.type.includes('image'))
                    {
                        this.formData[this.selectedUploadIndex].media_type = 'image';
                        this.formData[this.selectedUploadIndex].image = true;
                        this.formData[this.selectedUploadIndex].video = false;
                    }
                    else if (file.type.includes('video'))
                    {
                        this.formData[this.selectedUploadIndex].media_type = 'video';
                        this.formData[this.selectedUploadIndex].image = false;
                        this.formData[this.selectedUploadIndex].video = true;
                    }
                    else{
                        this.toaster('file type not supported.', 201);
                        return;
                    }

                    this.formData[this.selectedUploadIndex].file  = file;
                    this.formData[this.selectedUploadIndex].src   = URL.createObjectURL(file);
            }
        },
        mounted() {
            this.getData();
        },
        updated() {},
        destroyed() {}
    }

</script>
<style lang="scss">
    .my-purchase-review {
        background-color: #f4f4f4;

        .rate-head-container,
        .rate-card-container {
            background-color: #fff;
        }

        .rate-head {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &__label {
                display: flex;
                align-items: center;
            }

            &__review {
                text-align: center;

                img {
                    margin: .5rem;
                }
            }
        }

        .rate-card {
            &__head {
                display: flex;
                align-items: flex-start;
                border-bottom: 1px solid rgba(#000, .1);
                padding: 1rem;
            }

            &__image {
                background-size: contain;
                background-position: center;
                background-repeat: no-repeat;
                height: 60px;
                width: 60px;
            }

            &__video {
                border: 1px solid rgba(#000,.1);
            }

            &__actions {
                padding: 1rem;
                text-align: center;
                border-bottom: 1px solid rgba(#000, .1);
            }

            &__textbox {
                padding: 1rem;
                margin-top: 1rem;

                .v-input__slot {
                    padding-left: 0 !important;
                    border: 1px solid rgba(#000, .1) !important;
                }

                textarea {
                    margin: 0;
                    background-color: #f4f4f4;
                    padding: 1rem;
                }
            }

            &__video {
                padding: 1rem;
                display: flex;
                flex-direction: column;

                video {
                    margin: auto;
                    width: 100%;
                }

                .rate-card__add-video {
                    margin-top: 8px;
                    padding-bottom: 1rem;
                    display: grid;
                    grid-template-columns: 1fr 1fr;
                }
            }
        }
    }

</style>
